"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _EnhancedFileInput_instances, _EnhancedFileInput_registerEvents, _EnhancedFileInput_onChange, _EnhancedFileInput_setClasses;
Object.defineProperty(exports, "__esModule", { value: true });
// Util
const merge_1 = require("../util/merge");
const attributes = {
    input: "data-ei-input",
    clear: "data-ei-clear",
};
class EnhancedFileInput {
    constructor(selector, config) {
        _EnhancedFileInput_instances.add(this);
        this.inputMap = new WeakMap();
        this.config = (0, merge_1.default)({
            classes: {
                hasFile: "has-file",
                dragOver: "drag-over",
            },
        }, config || {});
        // get all containers
        const containers = document.querySelectorAll(selector);
        if (!containers)
            return;
        // Initialise the enhanced file input
        containers.forEach((container) => {
            const input = container.querySelector(`[${attributes.input}]`);
            if (!input) {
                console.warn("EnhancedFileInput: No input with attribute 'data-ei-input' found in parent element.");
                return;
            }
            if (this.inputMap.has(input))
                return;
            this.inputMap.set(container, {
                input: input,
                clearButton: container.querySelector(`[${attributes.clear}]`),
                hasFile: false,
                dragOver: false,
            });
            __classPrivateFieldGet(this, _EnhancedFileInput_instances, "m", _EnhancedFileInput_registerEvents).call(this, container);
        });
    }
    // ------------- Public Methods -------------
    removeSingle(container, index = 0) {
        var _a;
        const instance = this.inputMap.get(container);
        if (!instance)
            return;
        // remove the file from the input
        const files = instance.input.files;
        if (files) {
            const dt = new DataTransfer();
            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                if (i !== index)
                    dt.items.add(file);
            }
            instance.input.files = dt.files;
        }
        if ((_a = instance.input.files) === null || _a === void 0 ? void 0 : _a.length) {
            instance.hasFile = true;
        }
        else {
            instance.hasFile = false;
        }
        __classPrivateFieldGet(this, _EnhancedFileInput_instances, "m", _EnhancedFileInput_onChange).call(this, container, instance);
        instance.input.dispatchEvent(new Event("change"));
    }
    removeAll(container) {
        const instance = this.inputMap.get(container);
        if (!instance)
            return;
        instance.input.value = "";
        instance.hasFile = false;
        __classPrivateFieldGet(this, _EnhancedFileInput_instances, "m", _EnhancedFileInput_onChange).call(this, container, instance);
        instance.input.dispatchEvent(new Event("change"));
    }
}
exports.default = EnhancedFileInput;
_EnhancedFileInput_instances = new WeakSet(), _EnhancedFileInput_registerEvents = function _EnhancedFileInput_registerEvents(container) {
    // get the input from the map
    const instance = this.inputMap.get(container);
    if (!instance)
        return;
    // click on input, open file modal
    container.addEventListener("click", (e) => {
        if (e.target === instance.input)
            return;
        if (e.target === instance.clearButton)
            return;
        instance.input.click();
    });
    // on input change
    instance.input.addEventListener("change", () => {
        var _a;
        if ((_a = instance.input.files) === null || _a === void 0 ? void 0 : _a.length) {
            instance.hasFile = true;
            if (this.config.onUpload)
                this.config.onUpload(container, instance);
        }
        else {
            instance.hasFile = false;
            instance.input.value = "";
            if (this.config.onClear)
                this.config.onClear(container, instance);
        }
        __classPrivateFieldGet(this, _EnhancedFileInput_instances, "m", _EnhancedFileInput_onChange).call(this, container, instance);
    });
    // drag and drop files
    container.addEventListener("dragover", (e) => {
        e.preventDefault();
        e.stopPropagation();
        instance.dragOver = true;
        __classPrivateFieldGet(this, _EnhancedFileInput_instances, "m", _EnhancedFileInput_onChange).call(this, container, instance);
    });
    container.addEventListener("dragleave", (e) => {
        e.preventDefault();
        e.stopPropagation();
        instance.dragOver = false;
        __classPrivateFieldGet(this, _EnhancedFileInput_instances, "m", _EnhancedFileInput_onChange).call(this, container, instance);
    });
    container.addEventListener("drop", (e) => {
        var _a, _b;
        e.preventDefault();
        e.stopPropagation();
        instance.dragOver = false;
        __classPrivateFieldGet(this, _EnhancedFileInput_instances, "m", _EnhancedFileInput_onChange).call(this, container, instance);
        // Set files
        if ((_b = (_a = e.dataTransfer) === null || _a === void 0 ? void 0 : _a.files) === null || _b === void 0 ? void 0 : _b.length) {
            // check if the file supports multiple files
            if (instance.input.multiple) {
                instance.input.files = e.dataTransfer.files;
            }
            else {
                const dt = new DataTransfer();
                for (let i = 0; i < e.dataTransfer.files.length; i++) {
                    const file = e.dataTransfer.files[i];
                    if (i === 0)
                        dt.items.add(file);
                    break;
                }
                instance.input.files = dt.files;
            }
            instance.hasFile = true;
            __classPrivateFieldGet(this, _EnhancedFileInput_instances, "m", _EnhancedFileInput_onChange).call(this, container, instance);
        }
        // trigger change event
        instance.input.dispatchEvent(new Event("change"));
    });
    // input clear button
    if (instance.clearButton) {
        instance.clearButton.addEventListener("click", () => {
            instance.input.value = "";
            instance.hasFile = false;
            __classPrivateFieldGet(this, _EnhancedFileInput_instances, "m", _EnhancedFileInput_onChange).call(this, container, instance);
            // trigger change event
            instance.input.dispatchEvent(new Event("change"));
        });
    }
}, _EnhancedFileInput_onChange = function _EnhancedFileInput_onChange(container, instance) {
    if (this.config.onChange)
        this.config.onChange(container, instance);
    __classPrivateFieldGet(this, _EnhancedFileInput_instances, "m", _EnhancedFileInput_setClasses).call(this, container, instance);
}, _EnhancedFileInput_setClasses = function _EnhancedFileInput_setClasses(container, instance) {
    // reset all classes
    container.classList.remove(this.config.classes.hasFile);
    container.classList.remove(this.config.classes.dragOver);
    // set the classes
    if (instance.hasFile)
        container.classList.add(this.config.classes.hasFile);
    if (instance.dragOver)
        container.classList.add(this.config.classes.dragOver);
};
